import React, {Component} from 'react';

import {Row, Col, Table, Button, Input} from 'reactstrap';
import {Modal, ModalHeader, ModalBody, ListGroup, ListGroupItem} from 'reactstrap';
import {PulseLoader} from 'halogenium';
import axios from 'axios';
import _ from 'lodash';

import {serverPath, getExtension} from "../common";
import ProblemDetailsBreadcrumb from '../breadcrumbs/ProblemDetailsBreadcrumb';
import SubmissionList from './SubmissionListComponent'
import SubmissionOptionsModals from './submissionOptions/SubmissionOptionsModalsComponent.js'
import TestCaseList from './submissionOptions/TestCaseListComponent.js'
import ModalAlert from "../ModalAlertComponent";
import EditTextData from './problemDetailsOptions/EditTextData.js';
import EditLimits from './problemDetailsOptions/EditLimits.js';
import ChangeTestCases from './problemDetailsOptions/ChangeTestCases.js';

import '../../css/problemDetails.css';
import {ViewReports} from "../ViewReportsModal";
import YesNoModal from "../YesNoModalComponent";
import MarkdownRender from "../MarkdownRendererComponent";

//Route: /p/courses/:courseId/topic/:topicId/problem/:problemId
class PProblemDetails extends Component {

	constructor(props)
	{
        super(props);
		this.state=
		{
			loaded:false,
			user:null,
			breadcumbData:
			{
				userPrefix:'p',
				topicId:0,
				courseId:0,
				courseName:'',
				topicName:'',
				problemName:''
			},
			forceUpdate:false,
			selected:0,
			showSubmitModal:false,
			graderMessage:'',
			modalAlertOpen:false,
			modalAlertMessage:'',
			file:null,
			graderOutput:null,

			/* Edit text data modal */
            editTextDataModalOpen: false,

			/* Edit time/memory limit modal */
			editLimitsModalOpen: false,

			/* Change test cases modal */
			changeTestCasesModalOpen: false,

			reports: [],
			deleteProblemModalOpen: false
        };

		this.onSubmissionListChange = this.onSubmissionListChange.bind(this);
		this.renderCenterArea = this.renderCenterArea.bind(this);

		this.onFileSelected = this.onFileSelected.bind(this);
		this.onSubmitClick = this.onSubmitClick.bind(this);
		this.hideModalAlert = this.hideModalAlert.bind(this);
		this.toggleSubmitModal = this.toggleSubmitModal.bind(this);

		/* Edit text data modal */
		this.showEditTextDataModal = this.showEditTextDataModal.bind(this);
		this.hideEditTextDataModal = this.hideEditTextDataModal.bind(this);

		/* Edit limits modal */
        this.showEditLimitsModal = this.showEditLimitsModal.bind(this);
        this.hideEditLimitsModal = this.hideEditLimitsModal.bind(this);

        /* Change test cases modal */
        this.showChangeTestCasesModal = this.showChangeTestCasesModal.bind(this);
        this.hideChangeTestCasesModal = this.hideChangeTestCasesModal.bind(this);

        /* Delete problem modal */
		this.onYes = this.onYes.bind(this);
        this.toggleYesNoModal = this.toggleYesNoModal.bind(this);
     }

    /*Life cycle methods*/
	/**
	 * @description Use this function to auth user
	 **/
	componentDidMount()
	{
		axios.get(serverPath + "authService.php", {params:{action: 'whoIsLoggedIn'}})
			.then((response) =>
				{

					if(response.data !== null && response.data.roleName === "professor")
					{
						this.setState({user:response.data})
						this.getData();
					}
					else
					{
						this.props.history.push('/home');
					}
				});
	}

	/**
	 * @description Use this function to fetch data if props have changed
	 **/
	componentDidUpdate(prevProps)
	{
		if(prevProps.match.params.problemId !== this.props.match.params.problemId)
		{
			this.getData();
		}
	}

	/*Presenter code*/

	/**
	 * @description Use this function to fetch data from server
	 **/
	getData()
	{
		axios.get(serverPath+'professorService.php',
			{
				params:
				{
					action:'getProblemData',
					courseId:this.props.match.params.courseId,
					topicId:this.props.match.params.topicId,
					problemId:this.props.match.params.problemId
				}
			})
			.then((response)=>
				{
					this.setState(
						{
							loaded:true,
							courseName:response.data.courseName.name,
							problemData:response.data.problemData,
							topicName:response.data.topicName,
							problemSubmissions:response.data.problemSubimission.map((submission)=>{
								//this is added so that only submissions with review requests for this professor are
								// colored in red in SubmissionListComponent(line 171, or somewhere near)
								submission.hasReviewForLoggedProfessor = submission.reviewer !== null
																		&& submission.reviewer === this.state.user.userId;
								return submission;
							}),
							reports: response.data.reports,
							breadcumbData:
							{
								...this.state.breadcumbData,
								courseId:this.props.match.params.courseId,
								topicId:this.props.match.params.topicId,
								courseName:response.data.courseName.name,
								topicName:response.data.topicName,
								problemName:response.data.problemData.name
							},
							forceUpdate:!this.state.forceUpdate

						});
				});
    }

	toggleSubmitModal() {
		this.setState({ showSubmitModal: !this.state.showSubmitModal});
	}

	showModalAlert(message) {
		this.setState({
            modalAlertMessage: message,
            modalAlertOpen: true
        });
    }

	hideModalAlert() {
		this.setState({
           modalAlertOpen: false,
           modalAlertMessage: ""
        });
    }

    /******* EDIT TEXT DATA *******/
    showEditTextDataModal() {
        this.setState({ editTextDataModalOpen: true});
    }

    hideEditTextDataModal(problem) {
        if(problem !== null)
        	this.setState({ problemData: problem, editTextDataModalOpen: false});
        else
            this.setState({ editTextDataModalOpen: false});
    }

    /******* EDIT LIMITS *******/
    showEditLimitsModal() {
        this.setState({ editLimitsModalOpen: true});
    }

    hideEditLimitsModal(problem) {
        if(problem !== null)
            this.setState({ problemData: problem, editLimitsModalOpen: false});
        else
	        this.setState({ editLimitsModalOpen: false});
    }

    /****** CHANGE TEST CASES ********/
    showChangeTestCasesModal() {
        this.setState({ changeTestCasesModalOpen: true});
    }

    hideChangeTestCasesModal() {
        this.setState({ changeTestCasesModalOpen: false});
    }

    /******** TEST SOLUTION ************/
     /*
    * @param submissionId
    * @param graderTaskId
    * checks for status of submission with submissionId using graderTaskId for getting the info
    * */
	querySubmission(graderTaskId) {
		axios.get(serverPath + "submissionService.php",
			{
				params:
				{
        	        action: 'getTaskStatus',
        	        graderTaskId: graderTaskId,
        	    }
			})
			.then((response) =>
				{
					if( response.data.state === "finished" ||
						response.data.state === "compile_err" ||
						response.data.state === "malformed_request" ||
						response.data.state === "internal_error")
					{
						axios.get(serverPath + 'professorService.php',
							{
								params:
								{
									action:'getGraderOutput',
									graderName:
									this.state.problemData.graders[this.state.selected].graderName,
									problemId:this.props.match.params.problemId,
									graderMessage:response.data
								}
							})
							.then((response)=>
								{
									this.setState(
										{
											graderMessage:"Ocenjivanje završeno",
											graderOutput:response.data,
										});
								})
					}
					else
					{

						setInterval(this.querySubmission(graderTaskId), 200);
					}
				});
    }

	onFileSelected(e) {
        this.setState({
            file:e.target.files[0],
        });
    }

	onFileSubmit() {
        const params = new FormData();

        params.append('action', 'postSubmission');
        params.append('problemId', this.props.match.params.problemId);
        params.append('graderId', this.state.problemData.graders[this.state.selected].graderId);
        params.append('graderName', this.state.problemData.graders[this.state.selected].graderName);
        params.append('file', this.state.file);
        params.append('template', this.state.problemData.templateFileContent);

		axios.post(serverPath + "submissionService.php", params)
			.then((response) =>
			{
				if(response.data.hasOwnProperty('message')) {
					if(response.data.message === "Template mismatch") {
                        this.setState({graderMessage:"Niste iskoristili zadati šablon! Ne smete menjati ništa osim tela naznačene funkcije. Pokušajte ponovo.", graderResult: null});
                    } else if(response.data.message === "Problem with upload or storing of file") {
                        this.setState({graderMessage:"Greška na serveru(Problem with upload or storing of file). Ukoliko se ponovi molimo kontaktirajte nastavnika/administratora.", graderResult: null});
                    }
                } else {
                    const graderTaskId = response.data.graderTaskId;
					this.setState({graderMessage: 'Ocenjivanje u toku', graderOutput: null});
                    if(graderTaskId !== '')
                        this.querySubmission(graderTaskId);

                } 
            }
        );
    }

	onSubmitClick() {
		let extension = getExtension(this.state.problemData.graders[this.state.selected].graderId);
		if(this.state.file === null) {
            this.showModalAlert("Niste izabrali fajl!");
            return;
        }
        var indexOfDot = this.state.file.name.lastIndexOf(".");
		if(indexOfDot === -1) {
            this.showModalAlert("Loš fajl");
            return;
        }
        /*
        this check is necessary because, in case of multiple graders, user can select one grader, upload file for that grader
         and then change the grader and try to submit*/
		if(this.state.file.name.substr(indexOfDot,) !== extension) {
            this.showModalAlert("Ekstenzija fajla se ne poklapa sa izabranim ocenjivačem!");
            return;
        }
        this.onFileSubmit();
        this.toggleSubmitModal();
    }

    /********** DELETE PROBLEM ***********/
    onYes(){
        const params = new FormData();

        params.append('action', 'deleteProblem');
        params.append('problemId', this.props.match.params.problemId);

        axios.post(serverPath + "problemsService.php", params)
            .then((response) => {
                    if(response.data)
                        alert("Uspešno ste obrisali zadatak.");
                    else
                        alert("Došlo je do greške pri brisanju zadatka.")
                    window.history.back();
            });
	}

    toggleYesNoModal() {
    	this.setState({deleteProblemModalOpen: !this.state.deleteProblemModalOpen});
	}

    /********* SUBMISSION LIST ***********/
    onSubmissionListChange(submissionId, codeReview) {
        const index = this.state.problemSubmissions.findIndex((el)=>
        {

            return el.idProblemSubmission === submissionId;
        });

        this.setState((prevState)=>
        {
            var prev = prevState.problemSubmissions.slice(0, index);
            var next = prevState.problemSubmissions.slice(index+1);
            var curr = prevState.problemSubmissions[index];
            curr = {...curr, codeReview:codeReview, anwsered:true};
            return {
                problemSubmissions: prev.concat([curr], next),
                forceUpdate:!prevState.forceUpdate
            };
        });
    }

    /*Render code*/
	renderGraders() {
		let isSelected = _.fill(new Array(this.state.problemData.graders.length), false);
		isSelected[this.state.selected] = true;
		let arr = _.map(this.state.problemData.graders, (el, index)=>
			{
				return (
					<Col>
						<label>
							<input type='radio' name='graderSelecter'
								onClick = {()=>this.setState({selected:index})}
								checked={isSelected[index]}
							/>
							{el.graderName}
						</label>
					</Col>
					);
			});
		
		return (
			<Row>
				{arr}
			</Row>
		);
	}

	renderCenterArea(callbacks) {
		return (
			<React.Fragment>
				<ProblemDetailsBreadcrumb data={this.state.breadcumbData}/>
				<hr/>
				<div id ='problem' className='card'>
					<Row style={{paddingLeft:'20px'}} className='mt-3'>
						<Col xs={10}><h3>{this.state.problemData.name}</h3></Col>
						<Col>
							<ViewReports
								reports={this.state.reports}
								user={this.state.user}/>
						</Col>
					</Row>
					<Row className='problemText'>
						<Col>
							<MarkdownRender source = {this.state.problemData.text}
										   escapeHtml={false}
							/>
						</Col>
					</Row>
		
					<Row className = 'justify-content-center'>
						<Col xs='auto'>
							<Table className={'text-center'} size={'sm'}
								style={{'background-color': 'papayawhip'}}>
								<thead>
									<tr>
										<th> Programski jezici </th>
		    	                     	<th> Vremensko ograničenje </th>
		    	                     	<th> Memorijsko ograničenje </th>
		    	                     </tr>
		    	                </thead>
		    	                <tbody>
									<tr>
										<td>
											{this.renderGraders()}
										</td>
										<td> 
											<span className="fa fa-clock-o"></span> 
											{this.state.problemData.timeLimit} ms 
										</td>
										<td>
											<span className="fa fa-database"></span>
											{this.state.problemData.memoryLimit/1024/1024} MB
										</td>
		    	                    </tr>
		    	                </tbody>
							</Table>
						</Col>
					</Row>
				</div>

				<hr/>

				<div className="card">
                    <Row className='justify-content-center'>
                        <Col xs='auto'>
                            <ListGroup>
                                <ListGroupItem>
                                    <Row>
                                        <Col xs="auto">
                                            <Input type='file' onChange={this.onFileSelected}/>
                                        </Col>
                                        <Col xs="auto">
                                            <Button color='primary' onClick={this.onSubmitClick}> Testiraj zadatak </Button>
                                        </Col>
                                    </Row>
                                </ListGroupItem>
                                <ListGroupItem>
                                    <Button color='warning' onClick={this.showEditTextDataModal} style={{margin: '5px'}}> Izmeni naslov/tekst/redni broj </Button>
                                    <Button color='warning' onClick={this.showEditLimitsModal} style={{margin: '5px'}}> Izmeni memorijsko/vremensko ograničenje </Button>
                                    <Button color='warning' onClick={this.showChangeTestCasesModal} style={{margin: '5px'}}> Izmeni test primere </Button>
                                </ListGroupItem>
                                <ListGroupItem>
                                    <Button color='danger' onClick={this.toggleYesNoModal}> Obriši zadatak </Button>
                                </ListGroupItem>
                            </ListGroup>
                        </Col>
                    </Row>
				</div>

				<EditTextData isOpen={this.state.editTextDataModalOpen} closeModalHandler={this.hideEditTextDataModal} problem={this.state.problemData}/>

                <EditLimits isOpen={this.state.editLimitsModalOpen} closeModalHandler={this.hideEditLimitsModal} problem={this.state.problemData}/>

                <ChangeTestCases isOpen={this.state.changeTestCasesModalOpen} closeModalHandler={this.hideChangeTestCasesModal} problem={this.state.problemData}/>

				<Modal isOpen={this.state.showSubmitModal} toggle={this.toggleSubmitModal}
					   className={'middleSizeModal'}>
					<ModalHeader toggle={this.toggleSubmitModal}>
						Grader procesi
					</ModalHeader>

					<ModalBody>
							<Row>
								<Col className={'text-center'}>
                                        {this.state.graderMessage}
                                 </Col>
                            </Row>
							<Row>
								<Col>
									{
										this.state.graderOutput &&
										<TestCaseList graderOutput={this.state.graderOutput}/>
									}
								</Col>
							</Row>
                    </ModalBody>

                </Modal>

                <ModalAlert showModal={this.state.modalAlertOpen} message={this.state.modalAlertMessage}
					closeModalHandler={this.hideModalAlert}/>

				<YesNoModal toggle={this.toggleYesNoModal}
							onYes={this.onYes}
							isOpen={this.state.deleteProblemModalOpen}
							title={"Brisanje zadatka"}
							body={"Da li ste sigurni da želite da obrišete zadatak?"}
                            yesText={"Da"}
                            noText={"Ne"}/>

				<hr/>

				<div className='card'>
					<SubmissionList
						submissions={this.state.problemSubmissions}
						group={true}
						{...callbacks}
						forceUpdate={this.state.forceUpdate}

					/>
				</div>

			</React.Fragment>
		);
	}

	render()
	{
		if(!this.state.loaded)
		{
			return <PulseLoader/>;
		}

		return (
			<SubmissionOptionsModals onSubmissionListChanged={this.onSubmissionListChange}
				userId = {this.state.user.userId}
				render={this.renderCenterArea}/>

		) ;
    }

}

export default PProblemDetails;
